import React, { useEffect, useRef } from "react";
import { loadScript } from "~utils";

const PolyvVideo = ({ src, className, hideControl = false }) => {
  const playerWrapper = useRef();
  const playerRef = useRef(null);

  useEffect(() => {
    loadScript(
      "https://player.polyv.net/resp/vod-player/latest/player.js"
    ).then(() => {
      if (!playerRef.current) {
        playerRef.current = window.polyvPlayer({
          wrap: playerWrapper.current,
          width: "100%",
          height: "100%",
          vid: src,
          autoplay: true,
          loop: true,
          skinLocation: hideControl ? 0 : 1,
        });
        // playerRef.current.on("s2j_onPlayerInitOver", function () {
        //   playerRef.current.j2s_resumeVideo();
        // });
      }
    });

    return () => {
      if (playerRef?.current) {
        playerRef.current.destroy();
      }
    };
  }, []);

  return <div ref={playerWrapper} className={className} />;
};

export default PolyvVideo;
